import { IVehicleSelection } from '@shared/types/IVehicleSelection';
import { IVehicleFilters } from '@unified-commerce/gpc-vue-storefront-search';

export const PRODUCT_CARD_ALT_IMG = '';
export const PRODUCT_DELIVERY_ESTIMATE_MESSAGE = 'Estimated to arrive on';
export const BRAND = 'Brand X';
export const BRAND_FULL_NAME = 'Brand X';
export const SEARCH_CATEGORY_TENANT_PREFIX = 'brand-x-categories';
export const SEARCH_CATEGORY_TENANT_PREFIX_TITLE = 'Brand X Categories';
export const SEARCH_CATEGORY_TENANT_PREFIX_HANDLE = 'brand-x-categories-';
export const SEARCH_CATEGORY_PROMOTIONS_PREFIX_HANDLE = 'promotions-';
export const SEARCH_CATEGORY_PATH_SEPERATOR = '>';
export const SEARCH_TOP_LEVEL_PROMOTION_CATEGORY_TITLE = `${SEARCH_CATEGORY_TENANT_PREFIX_HANDLE}promotions`;
export const PROMOTION_CATEGORY_SPLIT = 'Promotions>';
export const SEARCH_PROMOTION_ACTIVE_TAG = 'sales_promo_active';
export const CLEARANCE_TAG = 'clearance';
export const SEARCH_CATEGORY_HANDLE_SEPARATOR = '-';
export const SEARCH_CATEGORY_QUERY_SEPARATOR = '/';
export const SEARCH_BRAND_PREFIX_TITLE = 'Brand X Categories>Brand Categories';
export const SEARCH_BRAND_PREFIX_HANDLE = `${SEARCH_CATEGORY_TENANT_PREFIX_HANDLE}brand-categories`;
export const SEARCH_DEFAULT_TITLE_OPTION = 'Default Title';
export const BASE_SEARCH_PATH = '/search';
export const BRANDS_CATEGORY_IDENTIFIER = 'Brands';
export const BRAND_CATEGORIES_CATEGORY_IDENTIFIER = 'Brand Categories';
export const CATEGORY_ROUTE_PREFIX = 'parts';
export const STORYBLOK_SETTINGS = 'settings';
export const STORYBLOK_CATEGORY_ROUTE_PREFIX = `content/categories`;
export const IS_LOGIN_FROM_CHECKOUT_QUERY_PARAM = 'from-checkout';
export const IS_LOGIN_FROM_CHECKOUT_COOKIE = 'isloginfromcheckout';
export const PAGE_QUERY_PARAM = 'page';
export const PER_PAGE_QUERY_PARAM = 'per-page';
export const PRICE_RANGE_QUERY_PARAM = 'price-range';
export const QUANTITY_QUERY_PARAM = 'quantity';
export const SEARCH_VARIANT_INVENTORY_COUNT_FIELD = 'variants_inventory_count';
export const MAX_PRICE_RANGE_QUERY_PREFIX = 'up-to-';
export const MIN_PRICE_RANGE_QUERY_PREFIX = 'above-';
export const SEARCH_QUERY_PARAM = 'q';
export const PRODUCT_TYPE_QUERY_PARAM = 'product_type';
export const SIZE_OPTION_QUERY_PARAM = 'size';
export const COLOUR_OPTION_QUERY_PARAM = 'colour';
export const VEHICLE_CATEGORY_QUERY_PARAM = 'vehicle';
export const VENDOR_QUERY_PARAM = 'vendor';
export const ON_SALE_KEY = 'tags';
export const ON_SALE_QUERY_PARAM = 'on_sale';
export const HIDDEN_PRODUCT_TAG = 'hidden_product';
export const STYLE_FILTER_KEY = 'variant_metafield_plytix_brand_x_style';
export const PART_NUMBER_FILTER_KEY = 'meta.plytix.part_number';
export const STYLE_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_style';
export const MADE_TO_ORDER_FILTER = 'meta.plytix.made_to_order';
export const SAFETY_RATING_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_safety_rating';
export const SAFETY_RATING_FILTER_KEY = 'variant_metafield_plytix_brand_x_safety_rating';
export const MATERIAL_METAFIELD_FILTER_KEY = 'meta.plytix.material';
export const MATERIAL_FILTER_KEY = 'variant_metafield_plytix_material';
export const HELMET_TYPE_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_helmet_type';
export const HELMET_TYPE_FILTER_KEY = 'variant_metafield_plytix_brand_x_helmet_type';
export const FASTENER_TYPE_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_fastener_type';
export const FASTENER_TYPE_FILTER_KEY = 'variant_metafield_plytix_brand_x_fastener_type';
export const OIL_GRADE_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_oil_grade';
export const OIL_GRADE_FILTER_KEY = 'variant_metafield_plytix_brand_x_oil_grade';
export const RIDING_TYPE_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_riding_type';
export const RIDING_TYPE_FILTER_KEY = 'variant_metafield_plytix_brand_x_riding_type';
export const SEASONS_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_seasons';
export const SEASONS_FILTER_KEY = 'variant_metafield_plytix_brand_x_seasons';
export const TYRE_TYPE_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_tyre_type';
export const TYRE_TYPE_FILTER_KEY = 'variant_metafield_plytix_brand_x_tyre_type';
export const NUM_OF_CHAIN_LINKS_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_number_of_chain_links';
export const NUM_OF_CHAIN_LINKS_FILTER_KEY =
  'variant_metafield_plytix_brand_x_number_of_chain_links';
export const SPROCKET_TEETH_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_sprocket_teeth';
export const SPROCKET_TEETH_FILTER_KEY = 'variant_metafield_plytix_brand_x_sprocket_teeth';
export const CAPACITY_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_channel_capacity';
export const CAPACITY_FILTER_KEY = 'variant_metafield_plytix_brand_x_channel_capacity';
export const RIM_SIZE_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_channel_rim_size';
export const RIM_SIZE_FILTER_KEY = 'variant_metafield_plytix_brand_x_channel_rim_size';
export const RIM_WIDTH_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_channel_rim_width';
export const RIM_WIDTH_FILTER_KEY = 'variant_metafield_plytix_brand_x_channel_rim_width';
export const TYRE_RIM_FIT_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_channel_tyre_rim_fit';
export const TYRE_RIM_FIT_FILTER_KEY = 'variant_metafield_plytix_brand_x_channel_tyre_rim_fit';
export const TYRE_PROFILE_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_tyre_profile';
export const TYRE_PROFILE_FILTER_KEY = 'variant_metafield_plytix_brand_x_tyre_profile';
export const TYRE_WIDTH_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_channel_tyre_width';
export const TYRE_WIDTH_FILTER_KEY = 'variant_metafield_plytix_brand_x_channel_tyre_width';
export const OIL_TYPE_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_oil_type';
export const OIL_TYPE_FILTER_KEY = 'variant_metafield_plytix_brand_x_oil_type';
export const CHAIN_SIZE_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_chain_size';
export const CHAIN_SIZE_FILTER_KEY = 'variant_metafield_plytix_brand_x_chain_size';
export const AGE_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_age';
export const AGE_FILTER_KEY = 'variant_metafield_plytix_brand_x_age';
export const GENDER_METAFIELD_FILTER_KEY = 'meta.plytix.brand_x_gender';
export const GENDER_FILTER_KEY = 'variant_metafield_plytix_brand_x_gender';
export const SORT_BY_QUERY_PARAM = 'sort-by';
export const VEHICLE_IDS_FILTER_KEY = 'meta.fitment.vehicles';
export const PROMOTION_CATEGORY_PREFIX_TITLE = 'Promotion';
export const BRAND_CATEGORY_PREFIX_TITLE = 'Brand';
export const SEARCH_DERIVED_IN_STOCK_FIELD = 'meta.derivedRelevanceAndUi.inStock';
export const ADDITIONAL_PRODUCT_FIELDS = [];
export const SUBCATEGORY_TILES_TITLE_SUFFIX = 'by Range';

export const SPECIAL_ORDER_BADGE_COPY = '';
export const SPECIAL_ORDER_TOOLTIP_COPY = '';
export const HANDLING_TIME_COPY_DEFAULT = '';
export const HANDLING_TIME_SUFFIX = '';
export const OUT_OF_STOCK_TEXT_COPY = 'Out of Stock';
export const OUT_OF_STOCK_TOOLTIP_COPY = '';
export const FITMENT_SHOP_PARTS_PATH = '';

export const FITMENT = {
  EMPTY_MESSAGE: 'This product is vehicle specific. Add your vehicle to check if it fits.',
  EMPTY_MESSAGE_PLURAL:
    'The following products can be bike specific. Add your bike to check what fits.',
  SELECTED_VEHICLE_MESSAGE: 'Selected bike in your garage:',
  SHOW_PARTS_THAT_FIT_MESSAGE: 'Only show parts that fit this bike:',
  FITS_MESSAGE: 'This fits your vehicle',
  FITS_MESSAGE_SHORT: 'Fits your vehicle',
  DOES_NOT_FIT_MESSAGE: 'This does not fit your vehicle',
  ADD_VEHICLE: 'Add vehicle',
  CHANGE_VEHICLE_BUTTON: 'Change vehicle',
  DOES_NOT_FIT_BUTTON: 'Shop what fits',
  REMOVE_VEHICLE: 'Remove vehicle',
};

export const STOCK_STATUS = {
  OUT_OF_STOCK: 'Out of Stock',
  IN_STOCK: 'In Stock',
  SUPPORT_TEXT_WITH_STOCK: 'In-store & Delivery',
  SUPPORT_TEXT_NO_STOCK: 'In-store or Delivery',
  CONTACT_STORE_LINK_LABEL: 'Find a store',
  CONTACT_STORE_SUFFIX: 'for availability',
};

export const PAGE_ROUTES = {
  store: '/pages/stores',
};

export const FOOTER_HEADINGS = {
  ABOUT: 'About',
  SUPPORT: 'Help & Contact',
  ACCOUNT: 'Account',
  SHOP: 'Shop',
  SOCIAL_MEDIA: 'Connect with us',
};

export const SORT_OPTION_LIST = [
  {
    label: 'Most Relevant',
    value: 'most_relevant',
    queryParamName: null,
  },
  {
    label: 'Alphabetically, A - Z',
    value: 'title-ascending',
    queryParamName: 'title-ascending',
  },
  {
    label: 'Alphabetically, Z - A',
    value: 'title-descending',
    queryParamName: 'title-descending',
  },
  {
    label: 'Price, low - high',
    value: 'price-ascending',
    queryParamName: 'price-ascending',
  },
  {
    label: 'Price, high - low',
    value: 'price-descending',
    queryParamName: 'price-descending',
  },
  {
    label: 'Date, old - new',
    value: 'created-ascending',
    queryParamName: 'created-ascending',
  },
  {
    label: 'Date, new - old',
    value: 'created-descending',
    queryParamName: 'created-descending',
  },
];
export enum CartMetafieldKeys {
  'BUNDLE_SELECTED_VARIANTS' = '__bundleSelectedVariants',
}

export const APP_ICON_PATH = '~/static/icons/brand-x-app-icon-512x512.png';

// Auth
export const PRE_ACCESS_IDENTIFIER = 'resto-pre-auth';
export const SESSION_IDENTIFIER = 'resto-auth-token';

export const FILTER_MAKES = {
  holden: 'Holden',
  ford: 'Ford',
  chrysler: 'Chrysler',
  gm: 'GM',
  nissan: 'Nissan',
  'british-cars': 'British Cars',
  mazda: 'Mazda',
  toyota: 'Toyota',
};

// Vehicle selection
export const FORM_FIELD_CONFIG: IVehicleSelection[] = [
  {
    title: 'Make',
    label: 'MAKE',
    queryField: 'make' as keyof IVehicleFilters,
    isDisabled: false,
    options: [],
  },
  {
    title: 'Model',
    label: 'MODEL',
    queryField: 'model' as keyof IVehicleFilters,
    isDisabled: true,
    options: [],
  },
  {
    title: 'Year',
    label: 'YEAR',
    queryField: 'year' as keyof IVehicleFilters,
    isDisabled: true,
    options: [],
  },
];

export const PRODUCT_BACKORDER_MESSAGE = '';
